import { jsx as m } from "react/jsx-runtime";
import { useState as R, useRef as s, useEffect as x } from "react";
import { Box as a } from "@mui/material";
import { styles as d } from "./styles.js";
function L({
  columnId: u,
  onResize: w,
  onResizeStart: p,
  onResizeEnd: v
}) {
  const [e, i] = R(!1), n = s(null), t = s(null), l = s(null), g = (r) => {
    r.preventDefault(), i(!0), p(u);
    const o = l.current?.parentElement;
    o && (n.current = r.clientX, t.current = o.getBoundingClientRect().width);
  }, c = (r) => {
    if (!e || n.current === null || t.current === null) return;
    const o = r.clientX - n.current, h = Math.max(50, t.current + o);
    w(u, h);
  }, f = () => {
    e && (i(!1), v(), n.current = null, t.current = null);
  };
  return x(() => (e && (window.addEventListener("mousemove", c), window.addEventListener("mouseup", f)), () => {
    window.removeEventListener("mousemove", c), window.removeEventListener("mouseup", f);
  }), [e]), /* @__PURE__ */ m(a, { ref: l, sx: d.columnResizer, onMouseDown: g, children: /* @__PURE__ */ m(a, { sx: {
    ...d.resizerHandle
  } }) });
}
export {
  L as ColumnResizer
};
